// extracted by mini-css-extract-plugin
export default {"modelList":"styles_modelList__B+AAs","topLabel":"styles_topLabel__MMsu0","label":"styles_label__Yo2Ea","refresh":"styles_refresh__pxlgA","subtitle":"styles_subtitle__5M1aG"};